// extracted by mini-css-extract-plugin
module.exports = {"wrapper-checkbox":"AffordabilityFilterToggle_wrapper-checkbox__aMtlJ","item-label":"AffordabilityFilterToggle_item-label__8Qt8a"};